import React from 'react';
import { Redirect } from 'react-router-dom';
import { createAuthenticationComponent } from '@cp-shared-9/frontend-ui';
import { landingPagePath } from '../../components/navigation/paths';

export const Authentication = createAuthenticationComponent({
    onMissingAuthentication: <Redirect to={landingPagePath()} />,
});
